import { Component, Input, forwardRef , Self, OnInit} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { AlineacionEnum } from './radiobutton.enum';
import { SistemaService } from '@servicios/Sistema.Service';

declare var $: any;
declare function Focus(id : string) : any;

const noop = () =>
{
};

export const RADIO_VALUE_ACCESSOR: any =
  {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => RadioButtonComponent),
    multi: true,
  };

@Component({
    selector: 'radiobuttoncustom',
    templateUrl: 'radiobutton.component.html',
    styleUrls: ['radiobutton.component.scss'],
    providers: [RADIO_VALUE_ACCESSOR]
})
export class RadioButtonComponent implements ControlValueAccessor{

    public innerValue : any = "";
    
    private onTouchedCallback: () => void = noop;
    private onChangeCallback: (_: any) => void = noop;
    
    @Input() titulo : string = ""; // titulo del input
    @Input() disabled : boolean = false; // control deshabilitado
    @Input() grupo : string = ""; // La agrupacion de los radio button
    @Input() alineacion : AlineacionEnum = AlineacionEnum.Centrada; // control deshabilitado
    @Input() sinMargen : boolean = false; //indica si el control tiene margen o no
    @Input() radioValor : any = 0; //Este es el valor del radio button

    public id : number = 0;
    public AlineacionEnum = AlineacionEnum;

    constructor(public sistemaService : SistemaService) {
      this.sistemaService.numeroControl++;
      this.id = this.sistemaService.numeroControl;
    }

    ngOnInit() {
    }

    Focus(){
    }

    LimpiarValor(){
      this.valor = '';
      Focus("input" + this.id);
    }

      // control ngModel
    get valor(): any{
      return this.innerValue;
    };

      //set accessor including call the onchange callback
    set valor(nuevoValor: any){
        if (nuevoValor !== this.innerValue){
          this.innerValue = nuevoValor;
        }
    }

    registerOnChange(fn: any) {
      this.onChangeCallback = fn;
    }

    registerOnTouched(fn: any){
      this.onTouchedCallback = fn;
    }

    writeValue(valor: any) {
      if (valor !== this.innerValue){
        this.innerValue = valor;
        this.asignarvalor();
      }
    }

    asignarvalor(){
      if(this.innerValue === true && this.radioValor){
          this.innerValue = this.radioValor;
          this.onChangeCallback(this.innerValue);
      }
    }

    TeclaPresionada(tecla : any)
    {
      if(tecla.keyCode ==  13 || tecla.keyCode == 32)
      {
        this.valor = !this.valor;
      }
    }

    change(e:any){
      this.innerValue = e;
      this.onChangeCallback(e);
    }
}